import { render, staticRenderFns } from "./Inbound.vue?vue&type=template&id=4db61e6e&scoped=true&"
import script from "./Inbound.vue?vue&type=script&lang=js&"
export * from "./Inbound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db61e6e",
  null
  
)

export default component.exports